import { EppSolutionResponse } from '../../generated/api/eppSolutionResponse';
import { ConsumerBA } from './billingAccountUtils.js';
import type { BillingAccountsState } from '../../common/types/states.js';
import type { BillingAccount } from '../../generated/api/billingAccount.js';
import type { CompanyInfoResponse } from '../../generated/api/companyInfoResponse.js';
import type { ContactPerson } from '../../generated/api/contactPerson.js';
import type { AuthenticatedUser } from '../../public/site/authState';

export const getContactInfo = (user: AuthenticatedUser): ContactPerson => {
  return {
    firstName: user.firstName,
    lastName: user.lastName || '',
    email: user.email || '',
    phoneNumber: user.mobile || '',
    analyticsConsent: user.analyticsConsent,
    preferredLanguage: user.preferredLanguage,
    costCenter: user.costCenter,
    employeeNumber: user.employeeNumber,
    roles: user.contact?.person?.roles,
  };
};
// todo --> this should handle essearch results. Note -> header does not currently have all the needed fields
export const findPersonBillingAccount = (
  billingAccounts?: BillingAccountsState | BillingAccount[]
): BillingAccount | undefined => {
  if (Array.isArray(billingAccounts)) {
    return billingAccounts.find(ba => ba.sourceSystem === ConsumerBA);
  }
  return billingAccounts?.items?.find(billingAccount => billingAccount.sourceSystem === ConsumerBA);
};
export const isEppSolutionActive = (companyInfo?: CompanyInfoResponse) =>
  companyInfo?.eppSolution?.eppSolutionStatus === EppSolutionResponse.EppSolutionStatusEnum.ACTIVE;
